<template>
  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 lbl">
          <label>Entité :</label>
        </div>
        <div class="col">
          <Dropdown class="dropdown-height"
              v-model="entite"
              :options="entiteLibelles"
              optionValue="valeur"
              optionLabel="texte"
              scrollHeight="300px"
              :showClear="true"/>
        </div>
      </div>
      <div class="row pb5">
          <div class="col-4 lbl">
            <label>Genre :</label>
          </div>
          <div class="col">
            <Dropdown class="dropdown-height"
                v-model="genre"
                :options="genreLibelles"
                optionValue="valeur"
                optionLabel="texte"
                scrollHeight="300px"
                :showClear="true"/>
          </div>
      </div>
    </div>
  </div>
  <div class="row pt5">
    <div class="col">
      <Button label="Rechercher" v-on:click="rechercher"/>
    </div>
    <div class="col" >
      <Button label="Effacer critères" v-on:click="effacerCriteres"/>
    </div>
    <div class="col" >
      <Button label="Ajouter" v-on:click="ajouter"/>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>

export default {
  name: "CriteresRechercheNature",
  emits: ['rechercher', 'fermer'],
  data() {
    return {
      entite: null,
      genre: null,
      entiteLibelles: [],
      genreLibelles: [],
      critereRechercheNature: {},
    }
  },
  beforeMount() {
    this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
        .then((res) => {
            this.assignerListe(res.data.entiteDecision);
        });
    this.entite = Number(this.$route.params.entite);
    if (this.$route.params.genre !== null && this.$route.params.genre !== undefined) {
      this.genre = Number(this.$route.params.genre);
    }
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
    },
    rechercher(){
        let libelleRecherche = {};
        libelleRecherche.valeur = this.entite;
        libelleRecherche.enfant = {};
        libelleRecherche.enfant.valeur = this.genre;
        libelleRecherche.enfant.enfant = {};
        libelleRecherche.enfant.enfant.texte = this.nature;
        libelleRecherche.enfant.enfant.code = 'Nature';
        this.$emit('rechercher', libelleRecherche);
    },
    rechercherNature() {
      this.critereRechercheNature.entite = this.entite;
      this.critereRechercheNature.genre = this.genre;
      this.$emit('rechercher', this.critereRechercheNature);
    },
    effacerCriteres() {
      this.genre = null;
      this.entite = null;
    },
    ajouter() {
      this.$router.push({name: "ajouterNature", params: {entite: this.entite}});
    },
    fermer() {
      this.$emit('fermer');
    }
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        }).then((res) => {
          this.genreLibelles = res.data;
        });
      } else {
        this.genre = null;
        this.genreLibelles = [];
      }
    },
  }
}
</script>
